"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Root = exports.Item = void 0;
var _mui = require("@ori-ui/mui");
var _presentationUtils = require("@ori/presentation-utils");
const Root = exports.Root = (0, _mui.styled)(_mui.Tabs)(({
  theme
}) => ({
  backgroundColor: theme.palette.grey[50],
  gap: theme.spacing(6),
  width: '100%',
  [`.${_mui.tabsClasses.indicator}`]: {
    display: 'none'
  }
}));
const Item = exports.Item = (0, _mui.styled)(_mui.Tab, {
  shouldForwardProp: (0, _presentationUtils.shouldNotForwardProp)(['hoverActiveColor'])
})(({
  theme,
  hoverActiveColor
}) => ({
  color: theme.palette.text.primary,
  marginRight: theme.spacing(6),
  fontSize: '1.4rem',
  fontWeight: theme.typography.fontWeightBold,
  minWidth: 60,
  height: 51,
  maxWidth: 'unset',
  textTransform: 'uppercase',
  opacity: 1,
  whiteSpace: 'nowrap',
  '&:hover': {
    color: hoverActiveColor ?? theme.palette.text.secondary
  },
  '&:focus': {
    color: theme.palette.text.primary
  },
  '&:focus-visible': {
    color: theme.palette.text.primary,
    textDecoration: 'underline'
  },
  '&.active': {
    color: hoverActiveColor ?? theme.palette.text.secondary
  },
  [`&.${_mui.tabClasses.root}`]: {
    padding: '0'
  },
  [`&.${_mui.tabClasses.selected}`]: {
    color: hoverActiveColor ?? theme.palette.text.secondary
  },
  [theme.breakpoints.up('md')]: {
    marginRight: theme.spacing(6),
    fontSize: '1.4rem'
  }
}));
//# sourceMappingURL=categoryBar.js.map